import React, { useLayoutEffect, useState, useEffect, useRef } from 'react'
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ButtonGroup from '@mui/material/ButtonGroup';
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';
import { FormControl, Grid } from '@mui/material';
import { firstStep, setAdditionalData, setAllSteps, setClientContainPlan, setCodpmpol, setCurrentTab, setErrorEncrypt, setFirstFormCompleted, setFirstStep, setFrequentQuestions, setGlobalTab, setStateError, setStatePlanDetail, setTitularData } from '../redux/reducer/stepReducer/stepReducer';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DoneIcon from '@mui/icons-material/Done';
import { createErrorEmail, saveMenuTwo, saveTitularData, searchCities } from '../redux/reducer/stepReducer/thunks';
import { handleKeyDown, handleKeyDown2, validarFecha, isElderlyDate, corregirCaracteresRotos, mayorSetenta, COMPANY_BBVA, CODEMP_MUSIMUNDO } from '../utilities';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Spinner from '../components/Spinner';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/en-gb';
import Layout from '../components/Layout';
import { setLogin } from '../redux/reducer/authReducer/adminReducer';
import CustomSelect from '../components/CustomSelect';


const customStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '287px',
  bgcolor: '#ECE6F0',
  borderRadius: '20px',
  p: '16px',
};

const FormInfoUser = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [listActivities, setListActivities] = useState([]);
  const [listCities, setListCities] = useState([]);
  const [valueProvince, setValueProvince] = useState(null);
  const [valueCity, setValueCity] = useState(null);
  const backUpLogin = useSelector(state => state.adminReducer.login);
  const { codemp } = useSelector(state => state.adminReducer.login);
  const { codpmpol, titularData, firstStep, homeData, stateError, clientContainPlan, statePlanDetail, paramsMus, firstFormCompleted } = useSelector((state) => state.firstStep);
  const { activities, countries, provinces, cities } = useSelector(state => state.adminReducer.login);
  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState({
    name: false,
    lastname: false,
    dni: false,
    email: false,
    city: false,
    province: false,
    area: false,
    phone: false,
    address: false,
    numAddress: false,
    birthday: false,
    age: false,
    elderly: false,
    seventy: false,
    genre: false,
    activity: false,
    nationality: false,
    expose: false,
    areaphone: false
  });


  const nationalityRef = useRef(null);
  const provinceRef = useRef(null);
  const cityRef = useRef(null);
  const dniRef = useRef(null);
  const genreRef = useRef(null);
  const nameRef = useRef(null);
  const lastnameRef = useRef(null);
  const birthdayRef = useRef(null);
  const addressRef = useRef(null);
  const areaRef = useRef(null);
  const phoneRef = useRef(null);
  const emailRef = useRef(null);
  const activityRef = useRef(null);
  const exposeRef = useRef(null);
  const formContainerRef = useRef(null);

  const handleChange = async (name, value) => {
    if (name === 'dni' || name === 'area') {
      if (Number(value) < 0) {
        dispatch(setTitularData({ [name]: '' }));
      } else {
        dispatch(setTitularData({ [name]: value }));
      }
    } else dispatch(setTitularData({ [name]: value }));
    setError({ ...error, [name]: false });
    if (name === 'birthday') setError({ ...error, 'age': false, 'elderly': false, seventy: false });
    if (name === "province") await dispatch(searchCities(value, firstStep.codcia));
  };

  const handleCloseModalIsOpen = async () => {
    dispatch(setClientContainPlan(''));
    dispatch(setStateError(''));
    setModalIsOpen(false);
    return;
    // if (firstStep.codsec === '8') {
    //   onNextPage();
    // }
    // else return;
  };

  const onNextPage = async () => {
    await dispatch(saveTitularData({ ...firstStep, ...titularData }, codpmpol));
    if (firstStep.codsec === '8') {
      if (homeData.province) {
        try {
          setIsLoading(true);
          await dispatch(searchCities(homeData.province, firstStep.codcia));
          setIsLoading(false);
        } catch (error) {
          let message = `Error searchCities | ${error}`;
          dispatch(createErrorEmail(message));
          dispatch(setErrorEncrypt(true))
          navigate('/error');
        }
      }
      dispatch(setCurrentTab(2));
      dispatch(setGlobalTab(2.5));
      navigate('/datosHogar')
    };
    if (firstStep.codsec === '12') {
      dispatch(setCurrentTab(2));
      dispatch(setGlobalTab(2.6));
      navigate('/datosBeneficiario')
    };
    if (firstStep.codsec === '159' || firstStep.codsec === '161') {
      dispatch(setCurrentTab(2));
      dispatch(setGlobalTab(2.6));
      navigate('/datosTecnologia')
    };
    if (firstStep.codsec === '19' || firstStep.codsec === '62') {
      dispatch(setCurrentTab(3));
      navigate('/pago');
    };
  };

  const handleSubmit = async () => {
    if (!titularData.nationality) {
      setError({ ...error, nationality: true })
      nationalityRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (!titularData.province) {
      setError({ ...error, province: true })
      // provinceRef.current.focus();
      nationalityRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (!titularData.city) {
      setError({ ...error, city: true });
      dniRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (!titularData.dni || titularData.dni.length !== 7 && titularData.dni.length !== 8) {
      setError({ ...error, dni: true })
      dniRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (!titularData.birthday) {
      setError({ ...error, birthday: true });
      birthdayRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    const fechaIngresada = dayjs(titularData.birthday).format('DD/MM/YYYY')
    const age = validarFecha(fechaIngresada);
    const elderly = isElderlyDate(fechaIngresada);
    const seventy = mayorSetenta(fechaIngresada);

    if (seventy && firstStep.codsec === "12") {
      setError({ ...error, seventy: true });
      birthdayRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (elderly) {
      setError({ ...error, elderly: true });
      birthdayRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (!age) {
      setError({ ...error, age: true });
      birthdayRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (!titularData.address) {
      errorMessage = 'El domicilio es requerido'
      setError({ ...error, address: true, errorMessage })
      addressRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (firstStep.codcia === COMPANY_BBVA) {
      if (!titularData.numAddress) {
        errorMessage = 'Altura es requerido'
        setError({ ...error, numAddress: true, errorMessage })
        addressRef.current.focus();
        formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    } else {
      if (titularData.address.length < 5 /*|| !/^[a-zA-Z0-9ñÑ\s]+$/.test(titularData.address)*/) {
        errorMessage = 'Debe contener el domicilio y la altura, mínimo 5 caracteres'
        setError({ ...error, address: true, errorMessage })
        addressRef.current.focus();
        formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }
    if (/^\s|\s$/.test(titularData.address)) {
      dispatch(setTitularData({ 'address': titularData.address.trim() }));
    }
    if (!titularData.area || titularData.area[0] == "0" || titularData.area.length < 2 || titularData.area.length >= 5) {
      setError({ ...error, area: true })
      areaRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (!titularData.phone) {
      setError({ ...error, phone: true })
      phoneRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if ((titularData.phone.length + titularData.area.length) !== 10) {
      setError({ ...error, areaphone: true })
      phoneRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (!titularData.expose && (firstStep.codsec !== '161' && firstStep.codsec !== '159')) {
      setError({ ...error, expose: true })
      exposeRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    setIsLoading(true);
    await dispatch(saveMenuTwo({ ...firstStep, ...titularData /*, ...paramsMus*/ }, codemp, codpmpol));
    setIsLoading(false);
  };

  const nextForm = async () => {
    let errorMessage = '';
    if (!titularData.email || !/^.{4,}@[^@\s]+\.[^@\s]+$/.test(titularData.email) || titularData.email.split(' ').length > 1) {
      if (!titularData.email) {
        errorMessage = 'Email es requerido';
      } else if (!/@/.test(titularData.email)) {
        errorMessage = 'El email debe contener @';
      } else if (!/\.[a-zA-Z]{2,}$/.test(titularData.email)) {
        errorMessage = 'El email debe tener un dominio válido (por ejemplo, .com)';
      } else if (titularData.email.split('@')[0].length < 4) {
        errorMessage = 'El email debe tener al menos 4 caracteres antes del @';
      } else if (titularData.email.split(' ').length > 1) {
        errorMessage = 'El email no debe incluir espacios';
      } else if (/^\s|\s$/.test(titularData.address)) {
        errorMessage = 'Verifique espacios en blanco al inicio o al final'
      };
      setError({ ...error, email: true, errorMessage })
      emailRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (!titularData.name) {
      errorMessage = 'Nombre es requerido';
      setError({ ...error, name: true, errorMessage })
      nameRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (titularData.name.length < 3 || titularData.name.length >= 51) {
      errorMessage = 'Verifique nombre';
      setError({ ...error, name: true, errorMessage })
      nameRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (/^\s|\s$/.test(titularData.name)) {
      dispatch(setTitularData({ 'name': titularData.name.trim() }));
    }
    if (!titularData.lastname) {
      errorMessage = 'Apellido es requerido';
      setError({ ...error, lastname: true, errorMessage })
      lastnameRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (titularData.lastname.length < 3 || titularData.lastname.length >= 51) {
      errorMessage = 'Verifique apellido';
      setError({ ...error, lastname: true, errorMessage })
      lastnameRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (/^\s|\s$/.test(titularData.lastname)) {
      dispatch(setTitularData({ 'lastname': titularData.lastname.trim() }));
    }
    if (!titularData.genre) {
      setError({ ...error, genre: true })
      genreRef.current.focus();
      formContainerRef.current.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    setIsLoading(true);
    await dispatch(saveTitularData({ ...firstStep, ...titularData }, codpmpol));
    setIsLoading(false);
    dispatch(setFirstFormCompleted(true));
  };


  useEffect(() => {
    if (titularData.birthday !== '') {
      handleChange('birthday', titularData.birthday);
    };
  }, []);

  useEffect(() => {
    if (typeof (clientContainPlan) === 'boolean') {
      if (clientContainPlan) {
        setModalIsOpen(true);
      } else {
        dispatch(setClientContainPlan(''));
        dispatch(setStateError(''));
        onNextPage();
      }
    }
  }, [clientContainPlan]);

  useEffect(() => {
    if (titularData.city && titularData.province) {
      const foundProvince = provinces?.find((e) => e.value === titularData.province)
      const foundCity = cities?.find((e) => e.value === titularData.city)
      setValueCity(foundCity);
      setValueProvince(foundProvince);
    }
  }, []);

  useEffect(() => {
    if (titularData.nationality !== '54') {
      setValueProvince(null)
      handleChange('province', '')
    }
  }, [titularData.nationality]);

  useEffect(() => {
    if (error.province) {
      setError({ ...error, province: false });
    };
  }, [titularData.province]);

  useEffect(() => {
    if (error.areaphone) {
      setError({ ...error, areaphone: false });
    };
  }, [titularData.phone, titularData.area]);

  useEffect(() => {
    setError({ ...error, birthday: false, age: false, elderly: false, seventy: false })
  }, [titularData.birthday]);


  useEffect(() => {
    dispatch(setAllSteps(2));
    dispatch(setAdditionalData(''));
  }, []);

  useEffect(() => {
    dispatch(setFrequentQuestions(firstStep.codsec))
  }, [firstStep.codsec]);

  useEffect(() => {
    if (!codpmpol) {
      try {
        const getRecidLocalStorage = () => { return JSON.parse(localStorage.getItem('codpmpol')) || [] };
        const getFirstStepStorage = () => { return JSON.parse(localStorage.getItem('firstStep')) || [] };
        const storageCodpmpol = getRecidLocalStorage();
        const firststepStorage = getFirstStepStorage();
        if (Array.isArray(storageCodpmpol)) {
          let message = `Error Recid | FormInfoUser | Intencion: ${firststepStorage.nro} | Seccion: ${firststepStorage.codsec} | Cod-Producto: ${firststepStorage.codpro}`
          dispatch(createErrorEmail(message));
          dispatch(setErrorEncrypt(true))
          navigate('/error');
        } else {
          const getStorageTitularData = () => { return JSON.parse(localStorage.getItem('titularData')) || [] }
          dispatch(setCodpmpol(storageCodpmpol));
          dispatch(setFirstStep({ ...firstStep, ...firststepStorage }));
          const dataTitular = getStorageTitularData();
          dispatch(setTitularData({ ...dataTitular }));
        };
      } catch (error) {
        let message = `Error TitularData | ${error}`;
        dispatch(createErrorEmail(message));
        dispatch(setErrorEncrypt(true))
        navigate('/error');
      };
    };
  }, []);


  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      if (titularData.province !== '' && titularData.city !== '') {
        handleChange('city', titularData.city);
        handleChange('province', titularData.province);
      } else if (titularData.province !== '') {
        handleChange('province', titularData.province);
      } else {
        handleChange('city', '');
        handleChange('province', '');
      };
      handleChange('birthday', '');
      dispatch(setLogin(backUpLogin));
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (firstStep.codcia !== 34) handleChange('numAddress', null);
  }, []);

  useEffect(() => {
    localStorage.setItem("titularData", JSON.stringify(titularData));
  }, [titularData]);

  useEffect(() => {
    dispatch(setCurrentTab(2));
    dispatch(setGlobalTab(0));
    dispatch(setStatePlanDetail(''));
  }, []);

  useEffect(() => {
    const newActivities = activities?.map(item => ({
      value: item.value,
      label: corregirCaracteresRotos(item.label),
    }));
    setListActivities(newActivities);
  }, []);


  useEffect(() => {
    const dataCities = cities?.map(item => ({
      value: item.value,
      label: corregirCaracteresRotos(item.label),
    }));
    setListCities(dataCities);
  }, [cities])

  useEffect(() => {
    //Siempre que se monte el componente, primero se visualizará el primer formulario
    dispatch(setFirstFormCompleted(false));
  }, []);

  useEffect(() => {
    if (Number(paramsMus.nro) === 0 || paramsMus.nro === '') {
      let message = `Error por N° Intencion en Datos del Titular | N° ${paramsMus}`
      dispatch(createErrorEmail(message));
      dispatch(setErrorEncrypt(true));
      navigate('/error');
    };
  }, []);

  return (
    <div className='testdiv' >
      {
        isLoading ?
          <Spinner />
          :
          <Layout  >
            <div ref={formContainerRef} className='forms'>
              {
                <>
                  <p>Ingresá tus datos</p>
                  {
                    !firstFormCompleted ?
                      <>
                        <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '30ch' }, }} noValidate autoComplete="off" >
                          <TextField
                            error={error.email}
                            label="Email"
                            variant="outlined"
                            name='email'
                            type='text'
                            ref={emailRef}
                            onKeyDown={handleKeyDown2}
                            onChange={({ target }) => {
                              let updatedValue = target.value.trim();
                              updatedValue = updatedValue.replace(/[^a-zA-Z0-9!@#$%^&*()-_+=<>?/:;{}[\]|]/g, '');
                              //updatedValue = updatedValue.replace(/[^a-zA-Z0-9\s!@#$%^&*()-_+=<>?/:;{}[\]|]/g, '');
                              handleChange('email', updatedValue);
                            }}
                            value={titularData.email}
                            helperText={error.email ? error.errorMessage : ''}
                          // helperText={error.email ? 'El email es requerido' : ''}
                          />
                        </Box>
                        <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '30ch' }, }} noValidate autoComplete="off" >
                          <TextField
                            error={error.name}
                            label="Nombre"
                            variant="outlined"
                            name='name'
                            ref={nameRef}
                            type='text'
                            // onKeyDown={handleKeyDown2}
                            onChange={({ target }) => {
                              let updatedValue = target.value;
                              updatedValue = updatedValue.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
                              updatedValue = updatedValue.slice(0, 50); // Limitar a 50 caracteres
                              handleChange('name', updatedValue);
                            }}
                            value={titularData.name}
                            helperText={error.name ? error.errorMessage : ''}
                          />
                        </Box>
                        <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '30ch' }, }} noValidate autoComplete="off" >
                          <TextField
                            error={error.lastname}
                            label="Apellido"
                            variant="outlined"
                            name='lastname'
                            ref={lastnameRef}
                            type='text'
                            // onKeyDown={handleKeyDown2}
                            onChange={({ target }) => {
                              let updatedValue = target.value;
                              updatedValue = updatedValue.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
                              updatedValue = updatedValue.slice(0, 50); // Limitar a 50 caracteres
                              handleChange('lastname', updatedValue);
                            }}
                            value={titularData.lastname}
                            helperText={error.lastname ? error.errorMessage : ''}
                          />
                        </Box>
                        <Stack display={"flex"} justifyContent={"start"} width={"100%"} marginBottom={"3px"}><FormHelperText style={{ marginLeft: "12px" }}>Sexo</FormHelperText></Stack>
                        <div className='ButtonSexoDiv'>
                          <ButtonGroup
                            disableElevation
                            variant="contained"
                            ref={genreRef}
                          >
                            <Button
                              style={{
                                borderTopLeftRadius: 20,
                                borderBottomLeftRadius: 20,
                                borderTopRightRadius: 0,
                                borderBottomRightRadius: 0,
                                width: 130,
                                border: '1px solid rgba(73, 70, 79, 0.4)',

                              }}
                              color="buttoncustom"
                              onClick={() => handleChange('genre', 'M')}
                              startIcon={titularData.genre === "M" && titularData.genre !== "F" ? <DoneIcon /> : ''}
                            >Masculino
                            </Button>
                            <Button
                              style={{
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0,
                                borderTopRightRadius: 20,
                                borderBottomRightRadius: 20,
                                width: 130,
                                border: '1px solid rgba(73, 70, 79, 0.4)',
                              }}
                              color="buttoncustom"
                              onClick={() => handleChange('genre', 'F')}
                              endIcon={titularData.genre === "F" && titularData.genre !== "M" ? <DoneIcon /> : ''}
                            >Femenino</Button>
                          </ButtonGroup>
                        </div>
                        {
                          error.genre && <FormHelperText style={{ marginLeft: "12px", color: "red" }}>El género es requerido</FormHelperText>
                        }
                        < div className='contenedorBotones' >
                          <Stack spacing={1} direction="row" alignItems={'flex-center'}>
                            {/* <Button style={{ borderRadius: 20, textTransform: 'capitalize' }} size="medium" color="secondary" variant="outlined" onClick={() => navigate('/beneficiaryData')}>NO TOCAR</Button> */}
                            <Button style={{ borderRadius: 20, textTransform: 'capitalize' }} size="medium" color={CODEMP_MUSIMUNDO.includes(codemp) ? "secondary" : "blue"} variant="outlined" onClick={(e) => navigate('/elegirPlan')}>Atrás</Button>
                            <Button
                              style={{ borderRadius: 20, textTransform: 'capitalize' }}
                              size="medium"
                              color={CODEMP_MUSIMUNDO.includes(codemp) ? "secondary" : "blue"}
                              variant="contained"
                              type='submit'
                              // disabled={dataCompleted}
                              onClick={nextForm}> Continuar
                            </Button>
                          </Stack>
                        </div >
                      </>
                      :
                      <>
                        <FormControl sx={{ m: 1, width: "30ch" }} error={error.nationality} >
                          <InputLabel id="demo-simple-select-label">Nacionalidad</InputLabel>
                          <Select
                            value={titularData.nationality}
                            label="Nacionalidad"
                            onChange={({ target }) => handleChange('nationality', target.value)}
                            name='nationality'
                            ref={nationalityRef}
                          >
                            {/* <MenuItem value={''}>Nacionalidad</MenuItem> */}
                            {
                              countries?.map((e) => {
                                if (e.value !== '595') {
                                  return (
                                    <MenuItem value={e.value}>{e.label}</MenuItem>
                                  )
                                }
                              })
                            }
                          </Select>
                          {error.nationality && <FormHelperText>País es requerido</FormHelperText>}
                        </FormControl>
                        <FormControl error={error.province}>
                          <CustomSelect
                            // value={titularData.province === '' ? '' : titularData.province}
                            value={valueProvince}
                            options={[/*{ value: '', label: 'Provincia' }*/, ...provinces]}
                            label="Provincia"
                            name='province'
                            // onChange={(_, { value, label }) => handleChange('province', value)}
                            onChange={(_, newValue) => {
                              if (newValue) {
                                setValueProvince(newValue)
                                handleChange('province', newValue.value)
                              } else {
                                setValueProvince(null)
                                handleChange('province', '')
                              }
                              setValueCity(null)
                              handleChange('city', '')
                            }}
                            disabled={titularData.nationality === ""}
                            ref={provinceRef}
                            error={error.province}
                            helperText={'Seleccione una Provincia'}
                          />
                        </FormControl>
                        <FormControl error={error.city} >
                          <CustomSelect
                            value={valueCity}
                            options={[/*{ value: '', label: 'Localidad' },*/ ...listCities]}
                            label="Localidad"
                            name='city'
                            onChange={(_, newValue) => {
                              if (newValue) {
                                setValueCity(newValue)
                                handleChange('city', newValue.value)
                              } else {
                                setValueCity(null)
                                handleChange('city', '')
                              }
                            }}
                            ref={cityRef}
                            error={error.city}
                            disabled={titularData.province === ""}
                            helperText={'Seleccione una Localidad'}
                          />
                        </FormControl>
                        <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off" >
                          <TextField
                            error={error.dni}
                            label="DNI (Solo personas físicas)"
                            variant="outlined"
                            type='number'
                            name='dni'
                            inputProps={{ step: 1 }}
                            ref={dniRef}
                            onChange={({ target }) => {
                              handleChange('dni', target.value.slice(0, 8).replace(/\./g, ''));
                            }}
                            value={titularData.dni}
                            onKeyDown={handleKeyDown}
                            helperText={error.dni ? 'DNI requiere 7 u 8 dígitos' : ''}
                          />
                        </Box>
                        <div onKeyDown={handleKeyDown}>
                          <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '30ch' }, }} noValidate autoComplete="off" >
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                              <DesktopDatePicker
                                format="DD/MM/YYYY"
                                // defaultValue={titularData.birthday?.$d}
                                variant="outlined"
                                name='birthday'
                                label="Fecha de Nacimiento"
                                ref={birthdayRef}
                                value={dayjs(titularData.birthday)}
                                onChange={(date) => {
                                  handleChange('birthday', date);
                                }}
                                slotProps={{
                                  textField: {
                                    error: error.birthday || error.age || error.elderly || error.seventy,
                                    helperText: error.birthday ? 'La fecha de nacimiento es requerida' : error.age ? 'Debe ser mayor de edad' : error.elderly ? 'Verifique fecha de nacimiento' : error.seventy ? 'Personas mayores de 70 años no pueden adquirir este seguro' : '',
                                  }
                                }}
                              />
                            </LocalizationProvider>
                          </Box>
                        </div>
                        {
                          firstStep.codcia === COMPANY_BBVA ?
                            <Box component="form" sx={{ '& > :not(style)': { m: 0.8, width: '9ch' }, }} noValidate autoComplete="off" >
                              <TextField style={{ width: '20ch' }}
                                error={error.address || error.numAddress}
                                label="Domicilio"
                                variant="outlined"
                                name='address'
                                type='text'
                                ref={addressRef}
                                onChange={({ target }) => {
                                  handleChange('address', target.value.slice(0, 50).replace(/[^\wñÑáéíóúÁÉÍÓÚ\s]/g, ''));
                                }}
                                value={titularData.address}
                                // onKeyDown={handleKeyDown}
                                helperText={(error.address || error.numAddress) && error.errorMessage}
                              />
                              <TextField
                                error={error.numAddress}
                                label="Altura"
                                variant="outlined"
                                name='numAddress'
                                ref={addressRef}
                                type='number'
                                onChange={({ target }) => {
                                  handleChange('numAddress', target.value.replace(/\D/g, '').slice(0, 8));
                                }}
                                // onKeyDown={handleKeyDown}
                                value={titularData.numAddress}
                              // helperText={error.numAddress && error.errorMessage}
                              />
                            </Box>
                            :
                            <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '30ch' }, }} noValidate autoComplete="off" >
                              <TextField
                                error={error.address}
                                label="Domicilio"
                                type='text'
                                variant="outlined"
                                name='address'
                                ref={addressRef}
                                // onKeyDown={handleKeyDown2}
                                onChange={({ target }) => {
                                  handleChange('address', target.value.slice(0, 50).replace(/[^\w\sñÑáéíóúÁÉÍÓÚ]/g, ''));
                                }}
                                value={titularData.address}
                                helperText={error.address && error.errorMessage}
                              />
                            </Box>
                        }
                        <Box component="form" sx={{ '& > :not(style)': { m: 0.8, width: '9ch' }, }} noValidate autoComplete="off" >
                          <FormHelperText style={{ marginLeft: "9px" }}>Teléfono</FormHelperText>
                          <TextField
                            error={error.area}
                            label="Sin 0"
                            variant="outlined"
                            name='area'
                            type='number'
                            ref={areaRef}
                            onChange={({ target }) => {
                              let updatedValue = target.value;
                              updatedValue = updatedValue.replace(/\./g, '');
                              updatedValue = updatedValue.slice(0, 4);
                              handleChange('area', updatedValue);
                            }}
                            value={titularData.area}
                            onKeyDown={handleKeyDown}
                            helperText={error.area && 'Revise el área'}
                          />
                          <TextField style={{ width: '20ch' }}
                            error={error.phone || error.areaphone}
                            label="Sin 15"
                            variant="outlined"
                            name='phone'
                            type='number'
                            ref={phoneRef}
                            onChange={({ target }) => {
                              let updatedValue = target.value;
                              updatedValue = target.value.replace(/\D/g, '');
                              updatedValue = updatedValue.slice(0, 8);
                              handleChange('phone', updatedValue);
                            }}
                            onKeyDown={handleKeyDown}
                            value={titularData.phone}
                            helperText={error.phone ? 'Revise el teléfono' : error.areaphone ? 'Revise área o teléfono' : ''}
                          />
                          <div className="texthelper">
                            <FormHelperText>Código de área</FormHelperText><FormHelperText>Número telefónico</FormHelperText>
                          </div>
                        </Box>
                        {
                          (firstStep.codsec !== '159' && firstStep.codsec !== '161') &&
                          <>
                            <FormControl sx={{ m: 1, width: "30ch" }} error={error.activity === true}>
                              <InputLabel id="demo-simple-select-label">Actividad económica</InputLabel>
                              <Select
                                value={titularData.activity}
                                label="Actividad económica"
                                onChange={({ target }) => {
                                  handleChange('activity', target.value)
                                }}
                                name='activity'
                                ref={activityRef}
                              >
                                <MenuItem value={0}>NO DECLARADA - A INFORMAR</MenuItem>
                                {
                                  listActivities?.map((e) => (
                                    <MenuItem value={e.value}>{e.label}</MenuItem>
                                  ))
                                }
                              </Select>
                              {error.activity && <FormHelperText>La actividad económica es requerida</FormHelperText>}
                            </FormControl>
                            <div className="ButtonSexoDiv">
                              <FormHelperText error={error.expose}>¿Sos una persona políticamente expuesta?</FormHelperText>
                              <ButtonGroup
                                disableElevation
                                variant="contained"
                                aria-label="Disabled elevation buttons"
                                ref={exposeRef}
                              >
                                <Button
                                  style={{
                                    borderTopLeftRadius: 20,
                                    borderBottomLeftRadius: 20,
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0,
                                    width: 130,
                                    border: '1px solid rgba(73, 70, 79, 0.4)',

                                  }}
                                  color="buttoncustom"
                                  onClick={() => handleChange('expose', 'yes')}
                                  startIcon={titularData.expose === "yes" && titularData.expose !== "no" ? <DoneIcon /> : ''}
                                >Si</Button>
                                <Button
                                  style={{
                                    borderTopLeftRadius: 0,
                                    borderBottomLeftRadius: 0,
                                    borderTopRightRadius: 20,
                                    borderBottomRightRadius: 20,
                                    width: 130,
                                    border: '1px solid rgba(73, 70, 79, 0.4)',
                                  }}
                                  color="buttoncustom"
                                  endIcon={titularData.expose === "no" && titularData.expose !== "yes" ? <DoneIcon /> : ''}
                                  onClick={() => handleChange('expose', 'no')}
                                >No</Button>
                              </ButtonGroup>
                            </div>
                          </>
                        }
                        <div className='contenedorBotones' >
                          <Stack spacing={1} direction="row" alignItems={'flex-end'}>
                            {/* <Button style={{ borderRadius: 20, textTransform: 'capitalize' }} size="medium" color="secondary" variant="outlined" onClick={() => navigate('/beneficiaryData')}>NO TOCAR</Button> */}
                            <Button style={{ borderRadius: 20, textTransform: 'capitalize' }} size="medium" color={CODEMP_MUSIMUNDO.includes(codemp) ? "secondary" : "blue"} variant="outlined" onClick={(e) => dispatch(setFirstFormCompleted(false))}>Atrás</Button>
                            <Button
                              style={{ borderRadius: 20, textTransform: 'capitalize' }}
                              size="medium"
                              color={CODEMP_MUSIMUNDO.includes(codemp) ? "secondary" : "blue"}
                              variant="contained"
                              type='submit'
                              // disabled={dataCompleted}
                              onClick={handleSubmit}> Continuar
                            </Button>
                          </Stack>
                        </div >
                      </>
                  }
                </>
              }
            </div >
            <Modal
              open={modalIsOpen}
              onClose={handleCloseModalIsOpen}
              closeAfterTransition
            >
              <Fade in={modalIsOpen}>
                <Box sx={customStyles}>
                  <Typography id="transition-modal-title" variant="h6" component="h4" style={{ fontFamily: 'Roboto' }}>
                    Aviso de contratación
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1 }} style={{ fontFamily: 'Roboto' }}>
                    {stateError}
                    {
                      statePlanDetail?.length > 0 &&
                      statePlanDetail?.map((e, ix) => {
                        if (!e.startsWith(' ')) {
                          return (
                            <Typography color={CODEMP_MUSIMUNDO.includes(codemp) ? "secondary" : "blue"} variant="h8" style={{ fontFamily: 'Roboto' }}>
                              <li>
                                {e}
                              </li>
                            </Typography>
                          )
                        }
                      })
                    }
                  </Typography>
                  <div
                    className="contenedorBotones"
                    style={{
                      spacing: 9,
                      display: "flex",
                      flexDirection: "row",
                      margin: 13,
                      position: "relative",
                    }}
                  >
                    <Button
                      style={{ borderRadius: 20, textTransform: "capitalize" }}
                      size="medium"
                      color={CODEMP_MUSIMUNDO.includes(codemp) ? "secondary" : "blue"}
                      variant="contained"
                      type="submit"
                      onClick={handleCloseModalIsOpen}
                    >
                      Aceptar
                    </Button>
                  </div>
                </Box>
              </Fade>
            </Modal>
          </Layout >
      }
    </div >
  )
}

export default FormInfoUser;